import { useState, useEffect, useRef } from 'react';
import  styles from './ContactSidebar.module.css';
import { getFunctions, httpsCallable } from "firebase/functions";
import { useNotifications } from "../../utils/NotificationContext/NotificationContext";
import { useTranslation } from 'react-i18next';
import { storage, firestore, auth }  from "../../firebase/firebase.js";
import { doc, getDoc, collection, addDoc, orderBy, query, arrayUnion, onSnapshot, serverTimestamp } from "firebase/firestore";
import ReCAPTCHA from 'react-google-recaptcha';
import Button from '../ui/Button';


//https://www.google.com/recaptcha/admin/create
//https://www.google.com/recaptcha/admin/site/742797873


const ContactSidebar = ({ isOpen, onClose }) => {
  const sidebarRef = useRef();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState({ loading: false, success: null, error: null });
  const { t } = useTranslation();
  const { notify } = useNotifications();
  const RECAPTCHA_SITE_KEY = '6LcxMkYsAAAAAEtbiHqsxPuaLnpXt6BKeTKRZhRz';//'6LcxL2ErAAAAABh0XiGCwtfW9sqo8jl42bScjh5j';
  const recaptchaRef = useRef();

  const functions = getFunctions();
  const verifyCaptcha = httpsCallable(functions, 'verifycaptchav2');

  useEffect(() => {
	const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };

    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setStatus({ loading: false, success: null, error: null });
  };


  const OnChange = (token) => {
	  if (!form.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
		notify('error', 'Please enter a valid email.');
		return;
	  }
	  if (!form.message || form.message.trim().length < 10) {
		notify('error', 'Message must be at least 10 characters.');
		return;
	  }

	  setStatus({ loading: true, success: null, error: null });
	  try {
		//const token = await recaptchaRef.current.executeAsync();
		//recaptchaRef.current.reset();
		verifyCaptcha({ token: token }).then(async (result) => {
			const data = result.data;
			if(!data.success){
				notify('error', 'reCAPTCHA verification failed.');
				return;
			}
			else {
				await addDoc(collection(firestore, 'contactMessages'), {
				  ...form,
				  createdAt: serverTimestamp()
				});
				
				notify('success', 'Message submitted!');
				setStatus({ loading: false, success: null, error: null });
				setForm({ name: '', email: '', message: '' });
			}
		}).catch((error) => {
			notify("error", error.message);
		});
		
	  } catch (err) {
		console.error(err);
		notify('error', err.message);
		setStatus({ loading: false, success: null, error: null });
	  }
  };

	const handleSubmit = async (e) => {
		e.preventDefault();
		if(recaptchaRef != null) recaptchaRef.current.execute();
		return;
	};

  return (
    <div className={`${styles["contact-float"]} ${isOpen ? styles.open : ''}`} ref={sidebarRef}>
      <div className={`${styles["contact-float-header"]}`}>
        <h2>{t('ui.contactUs')}</h2>
         <Button variant="ghost" className={`${styles["contactclose-btn"]}`} onClick={onClose} aria-label="Close Contact Form">
	  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fca311" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
		<line x1="18" y1="6" x2="6" y2="18" />
		<line x1="6" y1="6" x2="18" y2="18" />
	  </svg>
	</Button>
      </div>
      <form className={`${styles["contact-float-form"]}`} onSubmit={handleSubmit}>
        <input name="name" value={form.name} onChange={handleChange} placeholder="Your Name" required />
        <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="Your Email" required />
        <textarea name="message" value={form.message} onChange={handleChange} placeholder="Your Message" required />
        <Button type="submit" variant="primary" className={`${styles["contactbtn-btn"]}`} disabled={status.loading}>
          {status.loading ? 'Sending...' : 'Send Message'}
        </Button>
        {status.success && <p className={`${styles["form-success"]}`} >{status.success}</p>}
        {status.error && <p className={`${styles["form-error"]}`} >{status.error}</p>}
      </form>
	  {isOpen == true ? <ReCAPTCHA sitekey={RECAPTCHA_SITE_KEY} size="invisible"  ref={recaptchaRef} onChange={OnChange} /> : <></>}
    </div>
  );
};

export default ContactSidebar;
